import { THEME_COLOR } from "config/profile_constants";
import { getTime, sub } from "date-fns";
import React from "react";
import Chart from "react-apexcharts";

const AreaChart = ({ chartData, categories }) => {
  const [data, setData] = React.useState([]);
  React.useMemo(() => {
    setData([
      ...chartData.map((each) => [getTime(new Date(each.date)), each.value]),
    ]);
  }, [chartData]);
  const series = [
    {
      name: "series-1",
      data: [...data],
    },
  ];

  const options = {
    colors: [THEME_COLOR],
    fill: {
      gradient: {
        enabled: true,
        opacityFrom: 0.8,
        opacityTo: 0.5,
      },
    },
    chart: {
      id: "area-datetime",
      type: "area",
      zoom: {
        autoScaleYaxis: true,
      },
    },
    tooltip: {
      x: {
        format: "dd MMM yyyy",
      },
    },

    xaxis: {
      type: "datetime",
      min: new Date(sub(new Date(), { days: 365 })).getTime(),
      tickAmount: 6,
      label: "datetime",
      // categories: [...chartData.map((each) => each.date)],
    },
    selection: "one_year",
    dataLabels: {
      enabled: false,
    },
  };

  return (
    <div className="chart-timeline">
      <Chart
        height="459px"
        options={options}
        series={series}
        type="area"
        width="100%"
      />
    </div>
  );
};

AreaChart.defaultProps = {
  chartData: [],
};

export default AreaChart;
